
  <layout>
  <app-lesson-header-bar *ngIf="lessonCard" [lessonCard]=lessonCard ></app-lesson-header-bar>
  <div [@all]=currentState (@all.done)="next($event)">
      <div *ngIf="currentState !== 'void'">


        <!-- <div id='lesson1Heading' class="welcomeContainer transition" *ngIf="id === '1' && !!loggedIn" >
            <h1 class="welcomeHeader inset transition">{{config?.lessonHeaderWelcome}}</h1>
            <p  class="welcomeBody inset transition">{{config?.lessonHeaderWelcomeMessage}}</p>
        </div> -->


        <div class="background transition inset" >
         

            <div class="container">
                  <div id="LessonIntro" class="left">
                    <h3 style="color: #E09A00;">{{config?.lessonHeaderIntroductionTitle}}</h3>
                    <p *ngIf="intro" style="text-align: justify;">
                      {{intro.body}}
                    </p>

                </div>

                  <div class="right">                                  
                      <vg-player 
                      (onPlayerReady)="onPlayerReady($event)"
                      *ngIf="!!video" 
                      class="video">
                      <video 
                        [vgMedia]="media" 
                        #media 
                        autoplay
                        id="headerVideo" 
                        preload="auto" 
                        controls 
                        [src]="video"
                        [vgHls]="video"
                        type="application/x-mpegURL"
                        class=video>
                      </video>
                    </vg-player>
                </div>
                </div>


                <div class="buttons">
                  <gradient-button  
                    *ngIf="lessonNumber <= 2 || (!!unlocked && !!profile)" 
                    (click)="gotoLesson()" >{{config?.lessonTemplateContinue}}</gradient-button> 

                  <div class=group>
                  <text-button
                    *ngIf="!profile"
                    (click)="um.openSignUp()"
                    color="grey"
                    highlight="rgba(0, 0, 0, 0.1)"
                    >{{config?.navRegister}}</text-button>

                  <text-button color="grey"
                    *ngIf="!profile"
                    highlight="rgba(0, 0, 0, 0.1)"
                    (click)="um.openLogin()" >{{config?.navLogin}}</text-button>
                  </div>  
                  <div class=group>
                    <!-- <p  class="anonymousWarning">{{config?.lessonHeaderNotUnlockedWarning(previousUnlocked)}}</p> -->
                    <text-button 
                      *ngIf="!unlocked && !!loggedIn"
                      color="red"
                      highlight="rgba(255, 0, 0, 0.1)"
                      (click)="gotoLessonHeader(previousUnlocked)" >{{config?.lessonHeaderBackToGuide}} {{previousUnlocked}}</text-button>
                  </div>
                  
                </div>
      
        </div>
      </div>
  </div>
</layout>